// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.ui-button[data-v-c365f886] {
  font-family: var(--button-font-family);
  font-size: var(--button-font-size);
  font-weight: var(--button-font-weigth);
  line-height: var(--button-line-height);
  display: flex;
  justify-content: center;
  position: relative;
  min-width: 8rem;
  transition: all 0.15s ease-in-out;
}
.ui-button[data-v-c365f886]::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: opacity 0.15s ease-in-out;
}
.ui-button[data-v-c365f886]:focus {
  outline: none;
}
.ui-button[data-v-c365f886]:hover {
  transform: translateY(1px);
  cursor: pointer;
}
.ui-button.with-icon[data-v-c365f886] {
  display: flex;
  justify-content: center;
  align-items: stretch;
}
.photo-icon[data-v-c365f886] {
  --image: url('/public/images/photo-icon.png');

  margin-left: 0.625rem;
  display: block;
  width: 1.25rem;
  -webkit-mask-image: var(--image);
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-image: var(--image);
  mask-repeat: no-repeat;
  mask-position: center;
  transition: all 0.15s ease-in-out;
}
.button-primary .photo-icon[data-v-c365f886] {
  background-color: var(--button-primary-color);
}
.button-additional .photo-icon[data-v-c365f886] {
  background-color: var(--button-additional-color);
}
.button-primary[data-v-c365f886] {
  background-color: var(--button-primary-background);
  color: var(--button-primary-color);
  border: var(--button-primary-border);
  border-radius: var(--button-primary-border-radius);
  text-transform: var(--button-primary-text-transform);
  padding: var(--button-primary-padding);
  opacity: var(--button-primary-opacity);
}
.button-primary[data-v-c365f886]::before {
  border-radius: var(--button-primary-border-radius);
  box-shadow: var(--button-primary-shadow-size)
    var(--button-primary-shadow-color);
  opacity: var(--button-primary-shadow-opacity);
}
.button-primary[data-v-c365f886]:hover {
  --button-primary-background: var(--button-primary-background-hover);
  --button-primary-color: var(--button-primary-color-hover);
  --button-primary-opacity: var(--button-primary-opacity-hover);
  --button-primary-border: var(--button-primary-border-hover);
}
.button-primary[data-v-c365f886]:hover::before {
  --button-primary-shadow-opacity: var(--button-primary-shadow-opacity-hover);
  --button-primary-shadow-color: var(--button-primary-shadow-color-hover);
}
.button-additional[data-v-c365f886] {
  background: var(--button-additional-background);
  color: var(--button-additional-color);
  border: var(--button-additional-border);
  border-radius: var(--button-additional-border-radius);
  text-transform: var(--button-additional-text-transform);
  padding: var(--button-additional-padding);
  opacity: var(--button-additional-opacity);
}
.button-additional[data-v-c365f886]::before {
  border-radius: var(--button-additional-border-radius);
  box-shadow: var(--button-additional-shadow-size)
    var(--button-additional-shadow-color);
  opacity: var(--button-additional-shadow-opacity);
}
.button-additional[data-v-c365f886]:hover {
  --button-additional-background: var(--button-additional-background-hover);
  --button-additional-color: var(--button-additional-color-hover);
  --button-additional-opacity: var(--button-additional-opacity-hover);
  --button-additional-border: var(--button-additional-border-hover);
}
.button-additional[data-v-c365f886]:hover::before {
  --button-additional-shadow-opacity: var(
    --button-additional-shadow-opacity-hover
  );
  --button-additional-shadow-color: var(--button-additional-shadow-color-hover);
}
.ui-button[data-v-c365f886]:disabled {
  opacity: 0.7;
  cursor: default;
  transform: none;
}
@keyframes spinning-data-v-c365f886 {
from {
    transform: rotate(0deg);
}
to {
    transform: rotate(360deg);
}
}
.button-loader[data-v-c365f886] {
  margin-left: 0.5rem;
  animation-name: spinning-data-v-c365f886;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/UiButton.vue"],"names":[],"mappings":";AAkDA;EACA,sCAAA;EACA,kCAAA;EACA,sCAAA;EACA,sCAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,iCAAA;AACA;AAEA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,qCAAA;AACA;AAEA;EACA,aAAA;AACA;AAEA;EACA,0BAAA;EACA,eAAA;AACA;AAEA;EACA,aAAA;EACA,uBAAA;EACA,oBAAA;AACA;AAEA;EACA,6CAAA;;EAEA,qBAAA;EACA,cAAA;EACA,cAAA;EACA,gCAAA;EACA,8BAAA;EACA,6BAAA;EACA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iCAAA;AACA;AAEA;EACA,6CAAA;AACA;AAEA;EACA,gDAAA;AACA;AAEA;EACA,kDAAA;EACA,kCAAA;EACA,oCAAA;EACA,kDAAA;EACA,oDAAA;EACA,sCAAA;EACA,sCAAA;AACA;AAEA;EACA,kDAAA;EACA;sCACA;EACA,6CAAA;AACA;AAEA;EACA,mEAAA;EACA,yDAAA;EACA,6DAAA;EACA,2DAAA;AACA;AAEA;EACA,2EAAA;EACA,uEAAA;AACA;AAEA;EACA,+CAAA;EACA,qCAAA;EACA,uCAAA;EACA,qDAAA;EACA,uDAAA;EACA,yCAAA;EACA,yCAAA;AACA;AAEA;EACA,qDAAA;EACA;yCACA;EACA,gDAAA;AACA;AAEA;EACA,yEAAA;EACA,+DAAA;EACA,mEAAA;EACA,iEAAA;AACA;AAEA;EACA;;GAEA;EACA,6EAAA;AACA;AAEA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AACA;AAEA;AACA;IACA,uBAAA;AACA;AACA;IACA,yBAAA;AACA;AACA;AAEA;EACA,mBAAA;EACA,wCAAA;EACA,sBAAA;EACA,mCAAA;EACA,iCAAA;AACA","sourcesContent":["<template>\n  <button\n    :type=\"type\"\n    class=\"ui-button\"\n    :class=\"{\n      'button-additional': additional,\n      'button-primary': !additional,\n      'with-icon': !!photoIcon\n    }\"\n    :disabled=\"disabled || loading\"\n    :title=\"title\"\n    @click=\"$emit('click')\"\n  >\n    {{ title }}\n    <loader v-if=\"loading\" class=\"button-loader\" />\n    <i v-if=\"photoIcon\" class=\"photo-icon\" />\n  </button>\n</template>\n\n<script>\nimport Loader from '@src/components/images/Loader'\n\nexport default {\n  name: 'ui-button',\n  components: {\n    Loader\n  },\n  props: {\n    type: { type: String, default: undefined },\n    label: { type: String, default: undefined },\n    timer: { type: Number, default: undefined, required: false },\n    disabled: Boolean,\n    additional: Boolean,\n    photoIcon: Boolean,\n    loading: Boolean\n  },\n\n  computed: {\n    title() {\n      const { label, timer } = this\n      const buttonTitle =\n        timer !== undefined ? this.$t(label, { n: timer }) : this.$t(label)\n\n      return label && buttonTitle\n    }\n  }\n}\n</script>\n\n<style scoped>\n.ui-button {\n  font-family: var(--button-font-family);\n  font-size: var(--button-font-size);\n  font-weight: var(--button-font-weigth);\n  line-height: var(--button-line-height);\n  display: flex;\n  justify-content: center;\n  position: relative;\n  min-width: 8rem;\n  transition: all 0.15s ease-in-out;\n}\n\n.ui-button::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  transition: opacity 0.15s ease-in-out;\n}\n\n.ui-button:focus {\n  outline: none;\n}\n\n.ui-button:hover {\n  transform: translateY(1px);\n  cursor: pointer;\n}\n\n.ui-button.with-icon {\n  display: flex;\n  justify-content: center;\n  align-items: stretch;\n}\n\n.photo-icon {\n  --image: url('/public/images/photo-icon.png');\n\n  margin-left: 0.625rem;\n  display: block;\n  width: 1.25rem;\n  -webkit-mask-image: var(--image);\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  mask-image: var(--image);\n  mask-repeat: no-repeat;\n  mask-position: center;\n  transition: all 0.15s ease-in-out;\n}\n\n.button-primary .photo-icon {\n  background-color: var(--button-primary-color);\n}\n\n.button-additional .photo-icon {\n  background-color: var(--button-additional-color);\n}\n\n.button-primary {\n  background-color: var(--button-primary-background);\n  color: var(--button-primary-color);\n  border: var(--button-primary-border);\n  border-radius: var(--button-primary-border-radius);\n  text-transform: var(--button-primary-text-transform);\n  padding: var(--button-primary-padding);\n  opacity: var(--button-primary-opacity);\n}\n\n.button-primary::before {\n  border-radius: var(--button-primary-border-radius);\n  box-shadow: var(--button-primary-shadow-size)\n    var(--button-primary-shadow-color);\n  opacity: var(--button-primary-shadow-opacity);\n}\n\n.button-primary:hover {\n  --button-primary-background: var(--button-primary-background-hover);\n  --button-primary-color: var(--button-primary-color-hover);\n  --button-primary-opacity: var(--button-primary-opacity-hover);\n  --button-primary-border: var(--button-primary-border-hover);\n}\n\n.button-primary:hover::before {\n  --button-primary-shadow-opacity: var(--button-primary-shadow-opacity-hover);\n  --button-primary-shadow-color: var(--button-primary-shadow-color-hover);\n}\n\n.button-additional {\n  background: var(--button-additional-background);\n  color: var(--button-additional-color);\n  border: var(--button-additional-border);\n  border-radius: var(--button-additional-border-radius);\n  text-transform: var(--button-additional-text-transform);\n  padding: var(--button-additional-padding);\n  opacity: var(--button-additional-opacity);\n}\n\n.button-additional::before {\n  border-radius: var(--button-additional-border-radius);\n  box-shadow: var(--button-additional-shadow-size)\n    var(--button-additional-shadow-color);\n  opacity: var(--button-additional-shadow-opacity);\n}\n\n.button-additional:hover {\n  --button-additional-background: var(--button-additional-background-hover);\n  --button-additional-color: var(--button-additional-color-hover);\n  --button-additional-opacity: var(--button-additional-opacity-hover);\n  --button-additional-border: var(--button-additional-border-hover);\n}\n\n.button-additional:hover::before {\n  --button-additional-shadow-opacity: var(\n    --button-additional-shadow-opacity-hover\n  );\n  --button-additional-shadow-color: var(--button-additional-shadow-color-hover);\n}\n\n.ui-button:disabled {\n  opacity: 0.7;\n  cursor: default;\n  transform: none;\n}\n\n@keyframes spinning {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.button-loader {\n  margin-left: 0.5rem;\n  animation-name: spinning;\n  animation-duration: 1s;\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
